import React, { useState, useEffect } from 'react';
import './Contact.css';

export default function Contact() {

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll')
      .forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, service, message } = form;

    // Validation
    if (!name || !phone || !email || !message) {
      alert("Please fill all required fields!");
      return;
    }

    const whatsappNumber = "919370115694"; // without +

    const text = `
📩 *New Website Enquiry*

👤 Name: ${name}
📞 Phone: ${phone}
📧 Email: ${email}
🛠 Service: ${service || "Not Selected"}
📝 Message: ${message}
    `;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;

    // Open WhatsApp
    window.open(url, "_blank");

    // Show success message
    setSubmitted(true);

    // Reset form
    setForm({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">

      {/* HERO SECTION */}
     <section className="page-hero">
  <div className="container page-hero-content hero-animate">
    <span className="section-tag">Let's Connect</span>
    <h1>Contact <span>Us</span></h1>
    <p>
      Ready to grow your business online? Get in touch with our team for a free consultation.
    </p>
  </div>
</section>

      {/* CONTACT SECTION */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">

            {/* LEFT INFO */}
            <div className="contact-info animate-on-scroll">
              <h2>Get In <span>Touch</span></h2>
              <p>We'd love to hear from you. Reach out through any of the channels below, or fill in the form.</p>

              <div className="info-cards">

                <div className="info-card">
                  <div className="ic-icon">📍</div>
                  <div>
                    <h4>Visit Us</h4>
                    <p>
                      01, MV Plaza, Above ICICI Bank,<br />
                      Manvelpada Rd, Virar (E)-401305
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="ic-icon">📞</div>
                  <div>
                    <h4>Call Us</h4>
                    <a href="tel:+919370115694">+91 9370115694</a>
                  </div>
                </div>

                <div className="info-card">
                  <div className="ic-icon">✉️</div>
                  <div>
                    <h4>Email Us</h4>
                    <a href="mailto:info@dmstechnologies.in">info@dmstechnologies.in</a>
                  </div>
                </div>

                <div className="info-card">
                  <div className="ic-icon">💬</div>
                  <div>
                    <h4>WhatsApp</h4>
                    <a
                      href="https://wa.me/919370115694"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Chat on WhatsApp →
                    </a>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="contact-form-wrap animate-on-scroll">

              {submitted ? (
                <div className="success-msg">
                  <div className="sm-icon">✅</div>
                  <h3>Message Sent!</h3>
                  <p>Your enquiry has been sent via WhatsApp successfully.</p>
                  <button
                    className="btn-primary"
                    onClick={() => setSubmitted(false)}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (

                <form className="contact-form" onSubmit={handleSubmit}>

                  <h3>Send Us a Message</h3>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Your full name"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Phone Number *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="+91 XXXXXXXXXX"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Service Interested In</label>
                    <select
                      name="service"
                      value={form.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a service...</option>
                      <option>Social Media Marketing</option>
                      <option>Google Ads</option>
                      <option>Meta Ads</option>
                      <option>Website Development</option>
                      <option>E-Commerce Development</option>
                      <option>WhatsApp Marketing</option>
                      <option>Graphic Design</option>
                      <option>Domain & Hosting</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Your Message *</label>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Tell us about your business and goals..."
                      rows={5}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-primary"
                    style={{ width: '100%' }}
                  >
                    Submit & Send to WhatsApp 💬
                  </button>

                </form>
              )}

            </div>

          </div>
        </div>
      </section>

    </div>
  );
}